import { render, staticRenderFns } from "./postActivity.vue?vue&type=template&id=b7abf98e&scoped=true"
import script from "./postActivity.vue?vue&type=script&lang=js"
export * from "./postActivity.vue?vue&type=script&lang=js"
import style0 from "./postActivity.vue?vue&type=style&index=0&id=b7abf98e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7abf98e",
  null
  
)

export default component.exports